import React from 'react';
import './charts.css';

const BLUE = '#0066CC';

/** Horizontal bars sorted descending. `max` overrides the natural scale when
 *  two charts need to share one axis. */
export default function RankedBars({ rows = [], max }) {
  const sorted = [...rows].sort((a, b) => b.value - a.value);
  const top = max ?? (sorted.length ? sorted[0].value : 0);
  return (
    <div className="ranked">
      {sorted.map((r) => (
        <div key={r.key} className="ranked__row">
          <div className="ranked__label">{r.label}</div>
          <div className="ranked__track">
            <div
              data-testid={`ranked-bar-${r.key}`}
              data-key={r.key}
              className="ranked__bar"
              style={{ width: `${top > 0 ? (r.value / top) * 100 : 0}%`, background: BLUE, height: 18 }}
            />
          </div>
          <div className="ranked__value">{r.caption ?? r.value}</div>
        </div>
      ))}
    </div>
  );
}
